import { Observable } from 'rxjs';
import { $httpClient } from '@/services/httpClient';
import {
  APPLICATION_USER_RESET_PASSWORD,
  GET_APPLICATION_USER_INFO,
  GET_USER_CONTACT_DETAILS, UNLOCK_USER,
  UPDATE_USER_CONTACT_DETAILS,
} from '@/types/application-users.types';
import {
  BaseUserContactDetailsModel,
  UserContactDetailsModel,
} from '@/models/application-user/user-contact-details.model';
import { BaseResponse } from '@/models/response/base/BaseResponse';

export default class ApplicationUserService {
  private readonly baseApi: string;

  constructor() {
    this.baseApi = 'api/bo/';
  }

  public getApplicationUserInfo(idNumber): Observable<any> {
    return $httpClient.get<any>(this.baseApi + GET_APPLICATION_USER_INFO + '?userId=' + idNumber);
  }

  public getUserContactDetails(userDetails: BaseUserContactDetailsModel): Observable<UserContactDetailsModel> {
    return $httpClient.get<UserContactDetailsModel>(this.baseApi + GET_USER_CONTACT_DETAILS
      + '?indexNum=' + userDetails.indexNum + '&userId=' + userDetails.userId);
  }

  public updateUserContactDetails(userDetails: UserContactDetailsModel): Observable<BaseResponse> {
    return $httpClient.post<BaseResponse>(this.baseApi + UPDATE_USER_CONTACT_DETAILS, userDetails);
  }

  public unLockUser(userDetails: BaseUserContactDetailsModel): Observable<BaseResponse> {
    return $httpClient.post<BaseResponse>(this.baseApi + UNLOCK_USER
      + '?indexNum=' + userDetails.indexNum + '&userId=' + userDetails.userId);
  }

  public resetPassword(userDetails: BaseUserContactDetailsModel): Observable<BaseResponse> {
    return $httpClient.post<BaseResponse>(this.baseApi + APPLICATION_USER_RESET_PASSWORD
      + '?indexNum=' + userDetails.indexNum + '&userId=' + userDetails.userId);
  }
}
